import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    filterDropdownContainer: {
        zIndex: 10
    },
    filterSection: {
        flexWrap: "wrap",
        width: "100%",
        zIndex: 10
    },
    searchContainer: {
        minWidth: 250,
        flex: 1
    }
});

export default stylesheet;
